<template>
  <div v-html="content"></div>
</template>

<script>
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "Info",
  setup() {
    const data = reactive({
      content: "",
    });
    onMounted(() => {
      const route = useRoute();
      console.log(route.query.content);
      data.content = route.query.content;
    });
    return {
      ...toRefs(data),
    };
  },
});
</script>
<style lang="scss" scoped></style>
